import type { Locale } from './locale';

export const NUMBRO_LOCALES: Record<Locale, string> = {
  de: 'de-DE',
  en: 'en-US',
};

export default NUMBRO_LOCALES;
